// Statische Produkt-Metadaten. Die Preise kommen dynamisch aus /api/pricing (im Admin editierbar).
export const LICENSE_PRODUCTS = [
  {
    id: "einzel",
    name: "Einzel-Lizenz",
    seats: "1 Person",
    desc: "Voller Kurszugang für 1 Person + 30 Tage KI-Coach inklusive.",
    selectLabel: "Einzel-Lizenz auswählen",
  },
  {
    id: "team",
    name: "Team-Lizenz",
    seats: "bis 10 Personen",
    desc: "Voller Kurszugang für das ganze Team (bis 10 Personen) + 30 Tage KI-Coach pro Teammitglied inklusive.",
    note: "Die KI-Laufzeit wird zentral über das Büro verwaltet – Teammitglieder verlängern nicht einzeln.",
    selectLabel: "Team-Lizenz auswählen",
  },
];

export const FAIR_USE_NOTE =
  "Der KI-Coach ist als begleitender Fachassistent gedacht. Er unterstützt beim Verständnis der " +
  "Kursinhalte, bei Lichtplanungsideen, Projektfragen, Checklisten und der Anwendung des Wissens auf " +
  "konkrete Architekturprojekte. Die Nutzung erfolgt nach Fair-Use-Prinzip.";
